import {
  REMOVE_OPEN,
  ADD_OPEN,
  ADD_CONTENT,
  EDITOR_FOCUSED
} from "./actionTypes";

export const addOpen = (editorId) => ({
  type: ADD_OPEN,
  editorId: editorId
});

export const removeOpen = () => ({
  type: REMOVE_OPEN,
});

export const addContent = (copiedContent, attachmentIds) => ({
  type: ADD_CONTENT,
  copiedContent: copiedContent,
  attachmentIds: attachmentIds,
});

export const editorFocused = (editorId) => ({
  type: EDITOR_FOCUSED,
  editorId: editorId
})
